<template>
  <div class="row">
    <div class="col-lg-4 col-md-12" v-for="(item, index) in menu" :key="index">
      <div class="card o-hidden">
        <div class="chart-widget-top">
          <div class="row card-body">
            <div class="col-7">
              <h4 class="f-w-600" :class="item.class">{{ item.title }}</h4><span class="num"><span
                  class="counter">{{ item.count }}</span>%<i class="icon-angle-up f-12 ms-1"></i></span>
            </div>
            <div class="col-5 text-end">
              <h4 class="num total-value">{{ item.symbol }} <span class="counter">{{ item.counter }}</span>{{ item.point }}</h4>
            </div>
          </div>
          <div>
            <div id="chart-widget1">
              <apexchart height="170px" :options="item?.chart?.options" :series="item?.chart?.series"></apexchart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { top } from '../../../data/widgets/charts/data2'
export default {
  name: 'topPage',
  data() {
    return {
      menu: top
    }
  }
}
</script>